export const MasterySearchKeysModel = {
   term: null,
   level: null,
   subject: null,
};